"use client";

import {useEffect} from "react";
import {sendDiscoveryEventBeacon} from "@/lib/discoveryEventBeacon";

/**
 * Dedupes across React Strict Mode's mount→unmount→remount cycle.
 * Refs alone are not enough in React 19 Strict Mode, which remounts with
 * fresh state. Prefetch would also double-count if this still ran from a
 * Server Component render body — see `docs/tracking-strategy.md`.
 */
const firedCartIds = new Set<string>();

type TrackCartPageViewedProps = {
	/** Snake-cased cart payload, or `null` when the visitor has no cart yet. */
	cart: Record<string, unknown> | null;
};

/**
 * Fires Discovery's `cart_page_viewed` from a real client mount so Next.js
 * prefetch cannot double-count. Returns null (tracking-only).
 */
export function TrackCartPageViewed({cart}: TrackCartPageViewedProps) {
	useEffect(() => {
		const cartId = cart && typeof cart.id === "string" ? cart.id : "empty_cart";
		if (firedCartIds.has(cartId)) {
			return;
		}
		firedCartIds.add(cartId);

		sendDiscoveryEventBeacon("cart_page_viewed", cart ? {cart} : {}, {
			referrer: document.referrer || null,
		});
	}, [cart]);

	return null;
}
